/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MuDataProcessingModelsEditSource,
    MuDataProcessingModelsEditSourceFromJSON,
    MuDataProcessingModelsEditSourceFromJSONTyped,
    MuDataProcessingModelsEditSourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface MuDataProcessingModelsEdit
 */
export interface MuDataProcessingModelsEdit {
    /**
     * 
     * @type {string}
     * @memberof MuDataProcessingModelsEdit
     */
    editId?: string;
    /**
     * 
     * @type {Date}
     * @memberof MuDataProcessingModelsEdit
     */
    timestamp?: Date;
    /**
     * 
     * @type {MuDataProcessingModelsEditSource}
     * @memberof MuDataProcessingModelsEdit
     */
    source?: MuDataProcessingModelsEditSource;
}

export function MuDataProcessingModelsEditFromJSON(json: any): MuDataProcessingModelsEdit {
    return MuDataProcessingModelsEditFromJSONTyped(json, false);
}

export function MuDataProcessingModelsEditFromJSONTyped(json: any, ignoreDiscriminator: boolean): MuDataProcessingModelsEdit {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'editId': !exists(json, 'edit_id') ? undefined : json['edit_id'],
        'timestamp': !exists(json, 'timestamp') ? undefined : (new Date(json['timestamp'])),
        'source': !exists(json, 'source') ? undefined : MuDataProcessingModelsEditSourceFromJSON(json['source']),
    };
}

export function MuDataProcessingModelsEditToJSON(value?: MuDataProcessingModelsEdit | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'edit_id': value.editId,
        'timestamp': value.timestamp === undefined ? undefined : (value.timestamp.toISOString()),
        'source': MuDataProcessingModelsEditSourceToJSON(value.source),
    };
}


